export const LOCAL_STORAGE_KEY_NAME = 'setupSummaryBanner';
export const UPDATE_BANNER_DATA_EVENT = 'updateBannerData';
